import {Button, Col, Row, Space, Tabs, TabsProps} from "antd";
import {FormattedMessage} from "react-intl";
import AccessControl from "../components/common/AccessControl";
import {accessibilityRoles} from "../utils/accessUtils";
import DetailWrapper from "../components/common/DetailWrapper";
import GeneralData from "../components/nzis/GeneralData";
import ExcuseNotes from "../components/nzis/ExcuseNotes";
import React, {useContext, useEffect, useState} from "react";
import SignatureClientErrorModal from "../components/common/SignatureClientErrorModal";
import {InfoCircleOutlined} from "@ant-design/icons";
import {esignAppEndpoint} from "../i18n/nzis-utils";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";
import {Navigate} from "react-router-dom";
import Treatments from "../components/nzis/Treatments";

const Nzis = () => {
    const {userOrganization} = useContext(DentobookApplicationContext);

    const [isSignatureModalOpen, setSignatureModalOpen] = useState<boolean>(false);

    const items: TabsProps['items'] = [
        {
            label: <FormattedMessage id="all_data"/>,
            key: 'all_data',
            children: <GeneralData/>
        },
        {
            label: <FormattedMessage id="medical_prescriptions"/>,
            key: 'medical_prescriptions',
            children: <GeneralData/>
        },
        {
            label: <FormattedMessage id="excuse_notes"/>,
            key: 'excuse_notes',
            children: <ExcuseNotes/>
        },
        {
            label: <FormattedMessage id="treatments"/>,
            key: 'treatments',
            children: <Treatments/>
        },
    ];

    useEffect(() => {
        fetch(esignAppEndpoint, {
            method: 'post',
            headers: {
                'Accept': 'application/xml',
                'Content-Type': 'application/xml'
            },
            body: '<h1>Test</h1>'
        })
            .then(res => res.text())
            .then(res => {
                if (res === 'No certificate is chosen.') {
                    setSignatureModalOpen(true);
                }
            })
            .catch(() => setSignatureModalOpen(true));
    }, []);

    if (userOrganization?.country !== 'BG') {
        return <Navigate to={"/"}/>
    }

    return (
        <AccessControl
            accessibleFor={[accessibilityRoles.CLINIC_ADMIN]}>
            <SignatureClientErrorModal isModalOpen={isSignatureModalOpen} setIsModalOpen={setSignatureModalOpen}/>
            <DetailWrapper>
                <Row className="mb-2">
                    <Col span={12}>
                        <Space>
                            <h3><FormattedMessage id="nzis"/></h3>
                            <Button type="link"
                                    style={{marginLeft: -15, marginBottom: 0, fontSize: '16px', color: '#1444E1'}}
                                    onClick={() => setSignatureModalOpen(true)}>
                                <InfoCircleOutlined/>
                            </Button>
                        </Space>
                    </Col>
                </Row>
                <Tabs key="main-information" items={items}/>
            </DetailWrapper>
        </AccessControl>
    );
};

export default Nzis;